import React, { Component } from 'react';
import { CookieWrap, CookieText, CookieButton } from './CookieConsent.styled';

export default class CookieConsent extends Component {
  constructor() {
    super();
    this.hideCookieDisclaimerKey = 'HideCookieDisclaimer';
    this.acceptedCookieConsentValue = 'yes';
    this.onClickedAcceptCookieConsent = this.onClickedAcceptCookieConsent.bind(this);

    this.state = {
      acceptedCookieConsent: this.acceptedCookieConsent(),
    };
  }

  onClickedAcceptCookieConsent() {
    localStorage.setItem(this.hideCookieDisclaimerKey, this.acceptedCookieConsentValue);
    this.setState({
      acceptedCookieConsent: this.acceptedCookieConsent(),
    });
  }

  // Return boolean 
  acceptedCookieConsent() {
    return (localStorage.getItem(this.hideCookieDisclaimerKey) === this.acceptedCookieConsentValue);
  }

  render() {
    if (this.state.acceptedCookieConsent) {
      return null;
    }
    return (
      <CookieWrap>
        <CookieText>
        We use cookies to help create a brilliant online experience by monitoring how people use the site and to display adverts. By continuing to use our website you accept that cookies may be stored on your device. It&rsquo;s standard stuff,  but if you&rsquo;d like to know more, visit <a href='https://www.codecomputerlove.com/cookie-policy' target='_blank' rel='noopener noreferrer'>Cookie Policy</a>.
        </CookieText>
        <CookieButton onClick={this.onClickedAcceptCookieConsent}>Ok</CookieButton>
      </CookieWrap>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/cookie-consent/CookieConsent.js